import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetUserInvitationsByOrganizationIdQueryVariables = Types.Exact<{
  organization_id: Types.Scalars['uuid']['input'];
}>;


export type GetUserInvitationsByOrganizationIdQuery = { __typename?: 'query_root', user_invitations: Array<{ __typename?: 'user_invitations', id: any, email: string, status: string, created_at: any, properties_ids?: Array<string> | null, workspace_id?: any | null, organization_id?: any | null }> };


export const GetUserInvitationsByOrganizationIdDocument = gql`
    query getUserInvitationsByOrganizationId($organization_id: uuid!) {
  user_invitations(
    where: {organization_id: {_eq: $organization_id}}
    order_by: {created_at: asc}
  ) {
    id
    email
    status
    created_at
    properties_ids
    workspace_id
    organization_id
  }
}
    `;

/**
 * __useGetUserInvitationsByOrganizationIdQuery__
 *
 * To run a query within a React component, call `useGetUserInvitationsByOrganizationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserInvitationsByOrganizationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserInvitationsByOrganizationIdQuery({
 *   variables: {
 *      organization_id: // value for 'organization_id'
 *   },
 * });
 */
export function useGetUserInvitationsByOrganizationIdQuery(baseOptions: Apollo.QueryHookOptions<GetUserInvitationsByOrganizationIdQuery, GetUserInvitationsByOrganizationIdQueryVariables> & ({ variables: GetUserInvitationsByOrganizationIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserInvitationsByOrganizationIdQuery, GetUserInvitationsByOrganizationIdQueryVariables>(GetUserInvitationsByOrganizationIdDocument, options);
      }
export function useGetUserInvitationsByOrganizationIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserInvitationsByOrganizationIdQuery, GetUserInvitationsByOrganizationIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserInvitationsByOrganizationIdQuery, GetUserInvitationsByOrganizationIdQueryVariables>(GetUserInvitationsByOrganizationIdDocument, options);
        }
export function useGetUserInvitationsByOrganizationIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserInvitationsByOrganizationIdQuery, GetUserInvitationsByOrganizationIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserInvitationsByOrganizationIdQuery, GetUserInvitationsByOrganizationIdQueryVariables>(GetUserInvitationsByOrganizationIdDocument, options);
        }
export type GetUserInvitationsByOrganizationIdQueryHookResult = ReturnType<typeof useGetUserInvitationsByOrganizationIdQuery>;
export type GetUserInvitationsByOrganizationIdLazyQueryHookResult = ReturnType<typeof useGetUserInvitationsByOrganizationIdLazyQuery>;
export type GetUserInvitationsByOrganizationIdSuspenseQueryHookResult = ReturnType<typeof useGetUserInvitationsByOrganizationIdSuspenseQuery>;
export type GetUserInvitationsByOrganizationIdQueryResult = Apollo.QueryResult<GetUserInvitationsByOrganizationIdQuery, GetUserInvitationsByOrganizationIdQueryVariables>;